import {
    SET_DISPOSITION_PURCHASERS,
    GET_DISPOSITION_FEE_SCHEDULE,
    SET_DISPOSITION_COMMISSION,
    UPDATE_DISPOSITION_COMMISSION,
    SET_PROPERTY_FIELDS
} from "../../types";
import axios from "axios";
import { setAlert } from "../alert";
import { NumberValidator } from "../../../helpers/Validation";
export const getBudgetFeeSchedule = payload => async dispatch => {
    try {
        const res = await axios.post(
            `/properties/view/${payload.id}/fee_schedule`,
            { ...payload }
        );
        dispatch({
            type: GET_DISPOSITION_FEE_SCHEDULE,
            payload: res.data
        });
    }
    catch (error) {
        dispatch(setAlert("Failed", "error", 2000));
    }
};

//  This setPurchasers function responsible for loading Purchasers
//  at Property Dispostion tab
//  The function is trigger at properties => getPropertyAssets

export const setPurchasers = () => async(dispatch, getState) => {
    try {
    //  Destructre propertyFields from Redux state
        const { properties: { propertyFields } } = getState();

        //  Destructure puchasers from propertyFields
        const { purchasers } = propertyFields;

        //  Pre-defined empty array to allocate memory
        let purchaserList = [];

        //  saleTotal object contains fields that needed to be update within the property fields
        const saleTotal = {
            financial_sales_gross_amount: 0,
            financial_sales_gross_percent: 0,
            financial_disposition_fees: 0,
            financial_net_sale_proceeds: 0
        };

        //  If purchasers exists, decode it
        //  Loop through the lists and update needed fields
        if (purchasers) {
            purchaserList = JSON.parse(purchasers);
            purchaserList.length > 0 &&
                purchaserList.forEach(list => {
                    saleTotal.financial_sales_gross_amount += parseFloat(
                        list["Gross Sale Amount"] || 0
                    );
                    saleTotal.financial_sales_gross_percent += parseFloat(
                        list[
                            "Gross Sale Amount as a Percent of Net Approved Value"
                        ] || 0
                    );
                    saleTotal.financial_disposition_fees += parseFloat(
                        list["Disposition Fees"] || 0
                    );
                    saleTotal.financial_net_sale_proceeds += parseFloat(
                        list["Net Sale Proceeds"] || 0
                    );
                });
        }

        //  Create new propert fields object
        //  This is unnecessary but easier to understand
        const newPropertyFields = {
            ...propertyFields,
            ...saleTotal
        };

        // Dispatch an action to set new fields to the properties global object
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
        dispatch({
            type: SET_DISPOSITION_PURCHASERS,
            payload: purchaserList
        });
    }
    catch (error) {
        dispatch(
            setAlert("Update Purchasers Failed " + error.message, "error", 3000)
        );
    }
};

//  This updatePurchasers function responsible for updating Purchasers row
//  at Property Dispostion tab
//  The function takes in an event object

export const updatePurchasers = event => async(dispatch, getState) => {
    try {
    //  Destructre propertyFields from Redux state
        const { properties: { propertyFields } } = getState();
        //  Create a temporary fields object and update the target key
        let tempPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value
        };

        let saleTotal = {};
        switch (event.target.name) {
            case "purchasers": {
            //  Destructure puchasers from tempPropertyFields
                const { purchasers } = tempPropertyFields;

                //  saleTotal object contains fields that needed to be update within the property fields
                saleTotal = {
                    financial_sales_gross_amount: 0,
                    financial_sales_gross_percent: 0,
                    financial_disposition_fees: 0,
                    financial_net_sale_proceeds: 0
                };
                let purchaserList = [];

                //  If purchasers exists, decode it
                //  Loop through the lists and update needed fields
                if (purchasers) {
                //  Pre-defined empty array to allocate memory
                //  DESC: Parse purchasers list both old and new
                    purchaserList = JSON.parse(purchasers);

                    //  DESC: Check for purchaseList longer 0 - We don't really need to do this but I'll leave it here just in case.
                    //  DESC: Make calculation and set total. If item is NaN or empty. We'll set it to Zero 0
                    if (purchaserList.length > 0) {
                        const lastestBuyer =
                            //purchaserList[purchaserList.length - 1];
                            purchaserList[0];
                        //	DESC: get the latest settlement date and update property table with it.
                        tempPropertyFields = {
                            ...tempPropertyFields,
                            financial_settlement_date: lastestBuyer["Settlement Date"],
                            financial_settlement_date_projected: lastestBuyer["Projected Settlement Date"],
                            financial_sales_contract_offer_amount: lastestBuyer["Sales Contract Offer Amount"],
                            financial_sales_contract_offer_accepted_date: lastestBuyer["Date Contract Offer Accepted"],
                            financial_sales_gross_amount: lastestBuyer["Gross Sale Amount"],
                            financial_sales_cost: lastestBuyer[
                                "Total Sales Cost (Less Commissions)"
                            ],
                            financial_cost_of_real_estate_commissions: lastestBuyer["Cost of Real Estate Commissions"]
                        };

                        purchaserList.forEach(list => {
                            saleTotal.financial_sales_gross_amount += parseFloat(
                                list["Gross Sale Amount"] || 0
                            );
                            saleTotal.financial_sales_gross_percent += parseFloat(
                                list[
                                    "Gross Sale Amount as a Percent of Net Approved Value"
                                ] || 0
                            );
                            saleTotal.financial_disposition_fees += parseFloat(
                                list["Disposition Fees"] || 0
                            );
                            saleTotal.financial_net_sale_proceeds += parseFloat(
                                list["Net Sale Proceeds"] || 0
                            );
                        });
                    }
                }
                await dispatch({
                    type: SET_DISPOSITION_PURCHASERS,
                    payload: purchaserList
                });
                break;
            }
            case "status_secondary": {
            //  UNMARKETABLE FLAG (unmarketable)
            //  code=1 (id=10), code=2 (id=11), code=4 (id=12), code=5 (id=14), code=6 (id=15) the Unmarketable flag needs to be "N"
            //  adding null to the list of "N" values makes it default to "N"
                const nonMarketable = [null,
                    10,
                    11,
                    12,
                    14,
                    15];

                const {
                    status_secondary,
                    marketing_unmarketable_start_date,
                    marketing_unmarketable_end_date
                } = tempPropertyFields;

                if (
                    nonMarketable.includes(status_secondary) &&
                    (!marketing_unmarketable_start_date ||
                        marketing_unmarketable_end_date)
                ) {
                    tempPropertyFields.unmarketable = "N";
                }
                else {
                    tempPropertyFields.unmarketable = "Y";
                }
                break;
            }

            default:
                break;
        }

        //  Create new propert fields object
        //  This is unnecessary but easier to understand
        const newPropertyFields = {
            ...tempPropertyFields,
            ...saleTotal
        };
        // Dispatch an action to set new fields to the properties global object
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(
            setAlert("Update Purchasers Failed " + error.message, "error", 3000)
        );
    }
};

export const setCommission = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields: { commissions_json } } } = getState();
        if (!commissions_json) {
            return;
        }
        dispatch({
            type: SET_DISPOSITION_COMMISSION,
            payload: JSON.parse(commissions_json)[0]
        });
    }
    catch (error) {
        dispatch(
            setAlert("Update Comission Failed " + error.message, "error", 3000)
        );
    }
};

export const updateCommissionData = event => async(dispatch, getState) => {
    try {
    // DESC: TAX - UNDER PROTEST
        const { value, type, dataset } = event.target;
        //  DESC: Checking for number field and check for negative value. If negative, throw error
        //  DESC: isNumberNegative is a quick method to check for negative value. true or false
        if (type === "number") {
            if (NumberValidator.isNumberNegative(value)) {
                return dispatch(setAlert(
                    dataset.displayName + " can not be negative!",
                    "error"
                ));
            }
        }

        //  Destructure properties and propertyDisposition stores
        const {
            properties: { propertyFields: { financial_sales_gross_amount } },
            propertyDisposition: { CommissionData }
        } = getState();

        if (!financial_sales_gross_amount) {
            return dispatch(setAlert(
                "Gross sales value is not filled out; commission population will now halt"
            ));
        }

        //  Setting updated value into temporary state
        const newCommission = {
            ...CommissionData,
            [event.target.name]: event.target.value
        };

        //  Parse possible string to number
        const BrokerageFeePercent =
            parseFloat(newCommission.disposition_brokerage_fee_percent) || 0;
        const CommissionRatePercent =
            parseFloat(newCommission.contract_commission_rate_percent) || 0;
        const CommissionRateDollar =
            parseFloat(newCommission.contract_commission_rate_dollar) || 0;
        const PaidToBrokerDollar =
            parseFloat(newCommission.commission_paid_to_broker_dollar) || 0;
        const SalesGrossAmount = parseFloat(financial_sales_gross_amount) || 0;
        const Bonus = parseFloat(newCommission.bonus) || 0;

        newCommission.disposition_brokerage_fee_dollar =
            (SalesGrossAmount * BrokerageFeePercent) / 100;

        if (event.target.name === 'contract_commission_rate_dollar') {
            newCommission.contract_commission_rate_percent =
                (CommissionRateDollar / SalesGrossAmount) * 100;
        }
        else if (event.target.name === 'contract_commission_rate_percent') {
            newCommission.contract_commission_rate_dollar =
                (SalesGrossAmount * CommissionRatePercent) / 100;
        }

        newCommission.commission_paid_to_broker_percent =
            (PaidToBrokerDollar / SalesGrossAmount) * 100;

        const {
            contract_commission_rate_dollar,
            disposition_brokerage_fee_dollar
        } = newCommission;

        newCommission.gross_commission_earned =
            contract_commission_rate_dollar +
            disposition_brokerage_fee_dollar +
            Bonus;

        newCommission.net_commission_earned =
            newCommission.gross_commission_earned - PaidToBrokerDollar;
        dispatch({
            type: UPDATE_DISPOSITION_COMMISSION,
            payload: newCommission
        });
        return true;
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
        return false;
    }
};
export const clearCommissionData = () => (dispatch) => {
    dispatch({
        type: UPDATE_DISPOSITION_COMMISSION,
        payload: {
            bonus: "0.00",
            commission_paid_to_broker_dollar: "0.00",
            commission_paid_to_broker_percent: "0.00",
            contract_commission_rate_dollar: "0.00",
            contract_commission_rate_percent: "0.00",
            disposition_brokerage_fee_dollar: "0.00",
            disposition_brokerage_fee_percent: "0.00",
            gross_commission_earned: "0.00",
            gross_sales_amount: "0.00",
            net_commission_earned: "0.00"
        }
    });
};

export const populateCommission = () => async(dispatch, getState) => {
    try {
        const {
            properties: {
                propertyFields: {
                    id,
                    assignment_date,
                    type_primary,
                    property_management_occupancy_status,
                    financial_sales_gross_amount
                }
            }
        } = getState();
        if (!financial_sales_gross_amount) {
            return dispatch(setAlert(
                "Gross sales value is not filled out; commission population will now halt", 'error'
            ));
        }

        const payload = {
            id,
            assignment_date,
            type_primary,
            financial_sales_gross_amount,
            property_management_occupancy_status
        };

        await dispatch(getBudgetFeeSchedule(payload));

        const {
            propertyDisposition: {
                FeeSchedule: { contract_commission_rate },
                CommissionData: { bonus, commission_paid_to_broker_dollar }
            }
        } = getState();

        const newCommission = {
            gross_sales_amount: parseFloat(financial_sales_gross_amount),
            disposition_brokerage_fee_percent: 1.85,
            disposition_brokerage_fee_dollar: (parseFloat(financial_sales_gross_amount) * 1.85) / 100,
            contract_commission_rate_percent: parseFloat(
                contract_commission_rate
            ),
            contract_commission_rate_dollar: (parseFloat(financial_sales_gross_amount) *
                    parseFloat(contract_commission_rate)) /
                100,
            commission_paid_to_broker_percent: (parseFloat(commission_paid_to_broker_dollar) /
                    parseFloat(financial_sales_gross_amount)) *
                100
        };

        const {
            contract_commission_rate_dollar,
            disposition_brokerage_fee_dollar
        } = newCommission;

        newCommission.gross_commission_earned =
            contract_commission_rate_dollar +
            disposition_brokerage_fee_dollar +
            parseFloat(bonus);

        newCommission.net_commission_earned =
            newCommission.gross_commission_earned -
            parseFloat(commission_paid_to_broker_dollar);

        dispatch({
            type: SET_DISPOSITION_COMMISSION,
            payload: newCommission
        });
        dispatch(setAlert("Commission Populated", "success"));
        return true;
    }
    catch (error) {
        dispatch(
            setAlert("Populate Commission Failed", "error")
        );
        return false;
    }
};
